'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _defineProperty = _interopDefault(require('@babel/runtime/helpers/defineProperty'));
var React = require('react');
var PropTypes = _interopDefault(require('prop-types'));
var styled = _interopDefault(require('styled-components'));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var StyledLink = styled.a.withConfig({
  componentId: "sc-196beyx-0"
})(function (_ref) {
  var s = _ref.s;
  return _objectSpread(_objectSpread({
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    color: '#2b7cac',
    textDecoration: 'underline',
    border: 0,
    padding: 0,
    background: 'transparent'
  }, s && s.sDefault), {}, {
    '&:hover': _objectSpread({
      color: s && s.sDefault && s.sDefault.color || 'inherit',
      textDecoration: 'underline',
      cursor: 'pointer',
      background: 'transparent'
    }, s && s.sHover)
  });
});
(function (TextLinkTargetType) {
  TextLinkTargetType["SELF"] = "_self";
  TextLinkTargetType["BLANK"] = "_blank";
})(exports.TextLinkTargetType || (exports.TextLinkTargetType = {}));
var TextLink = function TextLink(_ref2) {
  var href = _ref2.href,
    children = _ref2.children,
    target = _ref2.target,
    rel = _ref2.rel,
    onClick = _ref2.onClick,
    linkStyle = _ref2.linkStyle,
    ariaLabel = _ref2['aria-label'],
    ariaControls = _ref2['aria-controls'],
    ariaExpanded = _ref2['aria-expanded'];
  return onClick && !href ? /*#__PURE__*/React.createElement(StyledLink, {
    as: "button",
    s: linkStyle,
    onClick: onClick,
    "aria-label": ariaLabel,
    "aria-controls": ariaControls,
    "aria-expanded": ariaExpanded
  }, children) : /*#__PURE__*/React.createElement(StyledLink, {
    s: linkStyle,
    href: href,
    target: target || exports.TextLinkTargetType.BLANK,
    rel: target === '_blank' ? "noopener noreferrer".concat(rel ? " ".concat(rel) : '') : rel,
    onClick: onClick,
    "aria-label": ariaLabel,
    "aria-controls": ariaControls,
    "aria-expanded": ariaExpanded
  }, children);
};
TextLink.defaultProps = {
  children: undefined,
  onClick: undefined,
  target: undefined,
  href: undefined,
  rel: undefined,
  linkStyle: undefined,
  'aria-label': undefined,
  'aria-controls': undefined,
  'aria-expanded': undefined
};
TextLink.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  target: PropTypes.oneOf([exports.TextLinkTargetType.SELF, exports.TextLinkTargetType.BLANK]),
  rel: PropTypes.string,
  href: PropTypes.string,
  linkStyle: PropTypes.shape({
    sDefault: PropTypes.object,
    sHover: PropTypes.object
  }),
  'aria-label': PropTypes.string,
  'aria-controls': PropTypes.string,
  'aria-expanded': PropTypes.bool
};

exports.default = TextLink;
